import React from "react"
import {iconPlus} from "../../Helper/Icons"
import style from "./AddItem.css"

export const AddItem = ({children, onClick}) => {
    return <div className={style.item} onClick={onClick}>
        {children}
        {iconPlus}
    </div>
}